import { Rule } from 'antd/lib/form';
import FormInput from 'components/Input/FormInput';
import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface ITimeBlockChildAccessField {
	changeTimeBlockChildAccess: (value: string) => void;
}

const TimeBlockChildAccessField: React.FC<ITimeBlockChildAccessField> = ({ changeTimeBlockChildAccess }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('enterTimeBlock') }], [t]);

	const handleChange = useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			const onlyDigits = e.target.value.replace(/\D/g, '');
			changeTimeBlockChildAccess(onlyDigits);
			return onlyDigits;
		},
		[changeTimeBlockChildAccess],
	);

	return (
		<FormInput
			testId="TimeBlockChildAccessField"
			name="timeBlockChildAccess"
			label="timeBlockLabel"
			getValueFromEvent={handleChange}
			validationRules={validationRules}
		/>
	);
};

export default React.memo(TimeBlockChildAccessField);
